import { ConsoleModal } from "apps/console/enums/ConsoleModal";
import Icon from "assets/icons";
import React from "react";
import { useSearchParams } from "react-router-dom";
import { DropdownItemConfig } from "shared/components/userDropdown/types";
import { useAuth } from "shared/context/auth";
import QueryParamKey from "shared/enums/QueryParamKey";
import { useCopies } from "shared/hooks/useCopies";

export default function useConsoleUserDropdownService() {
  const copies = useCopies();
  const { logout } = useAuth();
  const [searchParams, setSearchParams] = useSearchParams();

  const logoutHandler = React.useCallback(() => {
    logout();
  }, [logout]);

  const myProfileClickHandler = React.useCallback(
    e => {
      setSearchParams({
        ...Object.fromEntries(searchParams),
        [QueryParamKey.MODAL]: ConsoleModal.PROFILE
      });
    },
    [searchParams, setSearchParams]
  );

  const dropdownItemList: Array<DropdownItemConfig> = React.useMemo(() => {
    return [
      {
        label: copies.get("my.profile"),
        icon: <Icon.Person />,
        clickHandler: myProfileClickHandler
      },
      {
        icon: <Icon.Logout />,
        label: copies.get("logout"),
        clickHandler: logoutHandler,
        isNegativeAction: true
      }
    ];
  }, [copies, logoutHandler, myProfileClickHandler]);

  return {
    dropdownItemList
  };
}
